import { type FlowDocumentSearchBlockConfig } from 'flow-schema';

export function getDefaultDocumentSearchConfig(): FlowDocumentSearchBlockConfig {
  return {
    searchQuery: '',
  };
}
